import announcements from "@/frame/messages/mixins/announcements.js";
import { mapGetters } from "vuex";

export default {
  // eslint-disable-next-line
  data() {
    return {};
  },
  computed: {
    ...mapGetters([
      "getDocumentLogUserUnreadCounter",
      "getDocumentLogUserAttentionCounter"
    ])
  },
  mixins: [announcements],
  methods: {
    generateUserCountersMessage() {
      // GENERATE snackbar
      // let ctrUnread = this.getDocumentLogUserUnreadCounter;
      // let ctrAttention = this.getDocumentLogUserAttentionCounter;
      // if (ctrUnread === null || ctrUnread === undefined) {
      //   ctrUnread = 0;
      // }
      // if (ctrAttention === null || ctrAttention === undefined) {
      //   ctrAttention = 0;
      // }
      // let msg = "User " + ctrAttention + " monitor and ";
      // msg = msg + ctrUnread + " unread messages were found.";
      // GENERATE Snabar
      // this.generateInfoSnackbar(this.ui.colorSuccess, msg);
    }
  }
};
